// Authors control doc ordering by prefixing Outline titles with "N. " (e.g.
// "1. Overview"). The prefix is an ordering hint, not part of the title, so it
// drives sort order but is stripped for display. Whitespace after the dot is
// required so version-like titles ("1.2 Overview") are left untouched.
const ORDER_PREFIX = /^(\d+)\.\s+/;

/** Drop a leading "N. " ordering prefix for display. */
export function displayDocTitle(title: string): string {
  return title.replace(ORDER_PREFIX, "");
}

function leadingOrder(title: string): number | null {
  const match = ORDER_PREFIX.exec(title);
  return match ? Number(match[1]) : null;
}

/**
 * Order titles by their explicit "N. " prefix only. Prefixed titles sort ahead
 * of (and numerically among) un-prefixed ones; when neither carries a prefix
 * the comparator is neutral (0) so the caller's fallback - Outline `position` -
 * decides. This keeps position authoritative for un-prefixed docs and preserves
 * parent/child hierarchy instead of reordering everything alphabetically.
 */
export function compareDocTitleOrder(a: string, b: string): number {
  const orderA = leadingOrder(a);
  const orderB = leadingOrder(b);
  if (orderA !== null && orderB !== null) return orderA - orderB;
  if (orderA !== null) return -1;
  if (orderB !== null) return 1;
  return 0;
}
